import React from 'react';

import {Email} from 'presentation/components/ChangeData/Email';
import {emailRegexValidation, FeaturesEnum, OperationStateTypesEnum} from 'presentation/constants';
import {useChangeDataProfile} from 'presentation/pages/private/hooks';
import {AccordionStateEnum} from '../../store/formAccordionStore/types';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {usePersonalData} from 'presentation/hooks';
import {useChangeDataAlertStore} from '../../store/changeDataAlertStore';
import {EmptyAlertEnum} from 'presentation/components/ChangeData/EmptyAlert/constants';
import {MyProfileEnum} from 'main/analytics/gaTagsEnum';

export function EmailField() {
	const {
		changeDataFormState,
		handleChangeDataFocus,
		handleSendEmailOtpCode,
		isModalOtpConfirmationOpen,
		resetOtpConfirmationModal,
		changingEmailState,
		onCancel,
		resetEmailErrorBoundary,
	} = useChangeDataProfile();

	const {currentEmail} = usePersonalData();

	const changeDataAlertState = useChangeDataAlertStore(state => state.status);

	const currentEmailIsInvalid = !emailRegexValidation.test(currentEmail || '');

	const {isEnabled: isNewProfileFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.ADD__PORTAL_FEATURE_NEW_PROFILE,
	);
	const showEmailError = changingEmailState === OperationStateTypesEnum.UNAVAILABLE;
	const showEmailForm =
		isNewProfileFeatureFlagEnabled ||
		(changeDataFormState.name === AccordionStateEnum.EMAIL && changeDataFormState.isFormActive);

	if (showEmailError) {
		return <Email.Error resetErrorBoundary={resetEmailErrorBoundary} />;
	}

	if (showEmailForm) {
		return (
			<Email.Form
				onCancel={() => onCancel(AccordionStateEnum.EMAIL)}
				onSave={handleSendEmailOtpCode}
				abandonError={isModalOtpConfirmationOpen.isAbandoned}
				resetAbandonError={resetOtpConfirmationModal}
				loading={changingEmailState === OperationStateTypesEnum.PENDING}
			/>
		);
	}

	if (currentEmail) {
		return (
			<Email.Data
				email={currentEmail}
				onOpenForm={() => handleChangeDataFocus(AccordionStateEnum.EMAIL, true)}
				status={changeDataAlertState}
				isEmailInvalid={currentEmailIsInvalid}
			/>
		);
	}
	return (
		<Email.Empty
			type={EmptyAlertEnum.EMAIL}
			onClick={() => handleChangeDataFocus(AccordionStateEnum.EMAIL, true)}
			dataTagId={MyProfileEnum.CLICK_CADASTRAR_EMAIL}
			inlineStyle
		/>
	);
}
